import React, { useContext, useEffect, useState } from "react";

import { UserContext } from "../../../contexts";
import {
  usePricesByDate,
  usePriceAnalytics,
  useRefreshPricingData,
} from "../../../product/hooks";

import ProductPricesView from "./ProductPricesView";

const ProductPrices = ({ product, checkUnderPrice, basePath, variant }) => {
  const { user } = useContext(UserContext);
  const [filters, setFilters] = useState({});
  const { prices, isLoadingPrices, errorPrices } = usePricesByDate(product);
  const { analytics } = usePriceAnalytics(product);
  const refreshPricingData = useRefreshPricingData(product?.id);

  if (
    !user?.is_admin &&
    !user?.can_see_trade_prices &&
    !user?.can_see_market_prices
  ) {
    return null;
  }

  const refresh = () => {
    refreshPricingData(product?.id);
  };

  if (checkUnderPrice?.underpriced) {
    refresh();
  }

  return (
    <ProductPricesView
      {...{
        user,
        product,
        prices,
        filters,
        analytics,
        onFiltersChange: (newFilters) => setFilters(newFilters),
        refresh,
        basePath,
        variant,
        isLoadingPrices,
        errorPrices,
      }}
    />
  );
};

export default ProductPrices;
